(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cubedlab-homepage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tcl-work-carousel')) {
  customElements.define('tcl-work-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.timer = null;
      this.paused = false;
      this.hovering = false;
      this.focused = false;
      this.onScreen = false;
      this.editor = !!window.Shopify?.designMode;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controls = this.querySelector('[data-controls]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.dots = this.querySelector('[data-dots]');
      this.dots.replaceChildren();
      this.controls.hidden = this.slides.length < 2;
      this.pauseButton.hidden = this.dataset.autoplay !== 'true' || this.motion.matches || this.editor;
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-label', `${i + 1} of ${this.slides.length}`);
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show photograph ${i + 1}`);
        dot.addEventListener('click', () => this.show(i, true), {signal});
        this.dots.append(dot);
      });
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), {signal});
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pauseButton.textContent = this.paused ? 'Play' : 'Pause';
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Start automatic slideshow' : 'Pause automatic slideshow');
        this.schedule();
      }, {signal});
      this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, {signal});
      this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this.isConnected) return;
        this.focused = this.contains(document.activeElement); this.schedule();
      }), {signal});
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, {signal});
      const stage = this.querySelector('.tcl-work-stage');
      stage.addEventListener('touchstart', e => {
        this.touch = e.touches.length === 1 ? [e.touches[0].clientX, e.touches[0].clientY] : null;
      }, {signal, passive:true});
      stage.addEventListener('touchend', e => {
        if (!this.touch) return;
        const dx = e.changedTouches[0].clientX - this.touch[0];
        const dy = e.changedTouches[0].clientY - this.touch[1];
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, {signal, passive:true});
      stage.addEventListener('touchcancel', () => { this.touch = null; }, {signal, passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => {
        this.pauseButton.hidden = this.dataset.autoplay !== 'true' || this.motion.matches || this.editor;
        this.schedule();
      }, {signal});
      this.addEventListener('shopify:block:select', e => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if (i >= 0) this.show(i, true);
      }, {signal});
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        this.onScreen = entries[0].isIntersecting; this.schedule();
      }, {threshold:0.1});
      this.observer.observe(this);
      this.show(0);
    }
    show(next, announce = false) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.querySelector('[data-count]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
      if (announce) this.querySelector('[data-status]').textContent = `Photograph ${this.index + 1} of ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.hovering || this.focused || !this.onScreen || document.hidden || this.motion.matches || this.editor) return;
      const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.timer = setTimeout(() => this.show(this.index + 1), interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
